import {useEventBus} from "@vueuse/core";

export const appResumeBus = useEventBus<'resume'>('app')

